var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManifestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3763 13.9993H10.043V12.3327H3.3763V13.9993ZM3.3763 10.666H10.043V8.99935H3.3763V10.666ZM1.70964 17.3327C1.2513 17.3327 0.858941 17.1695 0.532552 16.8431C0.206163 16.5167 0.0429688 16.1243 0.0429688 15.666V2.33268C0.0429688 1.87435 0.206163 1.48199 0.532552 1.1556C0.858941 0.82921 1.2513 0.666016 1.70964 0.666016H8.3763L13.3763 5.66602V15.666C13.3763 16.1243 13.2131 16.5167 12.8867 16.8431C12.5603 17.1695 12.168 17.3327 11.7096 17.3327H1.70964ZM7.54297 6.49935V2.33268H1.70964V15.666H11.7096V6.49935H7.54297Z",
    fill: "#0B4D89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManifestIcon);
export default __webpack_public_path__ + "static/media/manifest-icon.c285a6e5ef1b242bacb877bdbcdf3be3.svg";
export { ForwardRef as ReactComponent };